import { render, staticRenderFns } from "./GExamCreateConfirmViewCompetency.vue?vue&type=template&id=49442434&scoped=true&"
import script from "./GExamCreateConfirmViewCompetency.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateConfirmViewCompetency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49442434",
  null
  
)

export default component.exports